import { useSelector } from 'react-redux';
import styles from './FooterFloorPlanInfo.module.css';

export default function FooterFloorPlanInfo() {
    const floorPlanInfo = useSelector(state => state.features.floorPlanInfo);
    
    // Don't render if no floor plan info is available
    if (!floorPlanInfo) return null;
    
    const { name = '', sqft = 0, beds = 0, bath = 0, garageCount = 0 } = floorPlanInfo;
    
    return (
        <footer className={styles.footer}>
            <div className={styles.content}>
                <div className={styles.floorplanName}>
                    {name}
                </div>
                
                <div className={styles.details}>
                    <div className={styles.detailItem}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 21H21M3 18H21M5 18V14M19 18V14M9 18V14M15 18V14M3 14H21M5 14V10H19V14M7 10V7L12 4L17 7V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{sqft.toLocaleString()} Sq. Ft.</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 21V7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V21M3 21H21M3 21V19M21 21V19M3 11H21M12 5V11M7 15H10M14 15H17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{beds} Bedrooms</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 12H20C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM4 12V5C4 4.44772 4.44772 4 5 4H6C6.55228 4 7 4.44772 7 5V12M17 20V22M7 20V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{bath} Bathrooms</span>
                    </div>
                    
                    <div className={styles.detailItem}>
                        <svg className={styles.icon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 21V10L12 3L21 10V21H15V15H9V21H3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9 21V17C9 15.8954 9.89543 15 11 15H13C14.1046 15 15 15.8954 15 17V21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{garageCount}-Car Attached Garage</span>
                    </div>
                </div>
                
                <button className={styles.viewMoreBtn}>
                    View More Info
                </button>
            </div>
        </footer>
    );
}
